import { useNavigate } from "react-router-dom";
import imgNotFound from "../Assets/Logos/404.svg";
import imgHome from "../Assets/Logos/logo_BRK.svg";
import { NotFoundStyled } from "../Styles/pageNotFound";

export const NotFound = () => {
  const navigate = useNavigate();
  return (
    <NotFoundStyled>
      <img onClick={() => navigate("/")} src={imgNotFound} alt="" />
      <div>
        <h2>Pagina não encontrada voltar.</h2>
        <button onClick={() => navigate("/")}>
          <img src={imgHome} alt="" />
        </button>
      </div>
    </NotFoundStyled>
  );
};
